/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, delay, select, takeLatest } from 'redux-saga/effects';
import * as api from '@api/dxaScoring';
import { actions, DXAScoringFormSlice } from './DXAScoringForm.slice';
import {
  DXAScoringFormAction,
  DXAScoringFormState,
  DXAScoringFormSuccess,
} from './DXAScoringForm.types';

import { Resp, dispatch } from '../helpers';
import { runToast } from '../tools';
import { scoringFormUpdateAction } from 'src/pages/Readings/ReadingTaskPage/utils';
import { readerTaskSlice } from '../readerTask/readerTask.slice';
import { promiseCacheCreator } from '@dynamika-shared/utils/promiseCacheCreator';


export function* storeDXAInfoWorker(action: DXAScoringFormSuccess) {
  const data = action.payload;

  const currentVisit: ReturnType<
    typeof readerTaskSlice.selectors.selectCurrentVisit
  > = yield select(readerTaskSlice.selectors.selectCurrentVisit);

  const scoringFormCode = currentVisit?.scoringCode;

  if (!scoringFormCode) {
    return;
  }

  yield call(scoringFormUpdateAction, scoringFormCode, data);
}

export function* calculateDXAScoreFormWorker(args: DXAScoringFormAction) {
  const data: DXAScoringFormState['data'] = yield select(
    DXAScoringFormSlice.selectors.selectData
  );

  if (!data?.scores) {
    yield delay(1000);
  }

  try {
    const response: Resp<typeof api.calculateScoring> = yield call(
      api.calculateScoring,
      args.payload
    );

    yield dispatch(actions.calculateScoresSuccess(response.data));
  } catch (error) {
    yield call(runToast, 'error', 'Something went wrong');
    console.error('Calculate scoring form error', error);
  }
}

export function* DXAScoringFormSaga() {
  yield takeLatest(actions.calculateScores.type, calculateDXAScoreFormWorker);
  yield takeLatest(actions.calculateScoresSuccess.type, storeDXAInfoWorker);
}
